import axios from "axios";
import { API_BASE_URL } from "../config";
import { authHeaders } from "./utils/session";
import { installAuthInterceptors } from "../../setupAxiosInterceptors";

/**
 * The multipart client, for the screens that upload files.
 *
 * It needs its own instance only because every request it makes is
 * `multipart/form-data`. An instance created with `axios.create()` inherits
 * nothing that was registered on the default export, so without the line below
 * these calls went out with no session behaviour at all: they never carried
 * credentials cross-origin, and a 401 was final — no refresh, no retry — while
 * every other call on the same screen recovered by itself.
 *
 * Built once at module load rather than per render. The old version rebuilt it
 * on every call, which meant a new instance (and a fresh set of interceptors)
 * each time a component asked for it.
 */
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    ...authHeaders(),
    "content-type": "multipart/form-data",
  },
});

installAuthInterceptors(api);

/* Kept callable so the existing `Api()` call sites do not have to change; it
   hands back the same instance every time. */
const Api = () => api;

export default Api;
